export default __webpack_public_path__ + "static/bin-it-right-logo-e768a146d141194f7890c08319204894.svg";